import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);
import colors from 'vuetify/lib/util/colors'

export default new Vuetify({
    theme: {
        themes: {
          light: {
            primary: colors.green.darken2, // #E53935
            secondary: colors.grey.lighten3, // #FFCDD2
            accent: colors.green.accent4, // #3F51B5
          }
        },
      },
});
